import React from 'react';
import MsrChartImageDownloadMenu from './MsrChartImageDownloadMenu';

export interface MsrChartCaptureProps {
  id: string;
  chartTitle: string;
  children: React.ReactNode;
  downloadDisabled?: boolean;
  /** When true, image download is rendered by the child chart (e.g. CI treemap header). */
  hideImageDownload?: boolean;
}

/** Wraps an MSR chart for export capture (chart panel only — no slide header/observation). */
const MsrChartCapture: React.FC<MsrChartCaptureProps> = ({
  id,
  chartTitle,
  children,
  downloadDisabled = false,
  hideImageDownload = false,
}) => (
  <div id={id} className="relative h-full min-h-[22rem] min-w-0">
    {!hideImageDownload ? (
      <div className="absolute right-3 top-3 z-20">
        <MsrChartImageDownloadMenu
          elementId={id}
          chartTitle={chartTitle}
          disabled={downloadDisabled}
        />
      </div>
    ) : null}
    {children}
  </div>
);

export default MsrChartCapture;
